// Single HTTP client. Base URL from env (see .env.local), JWT Bearer auth.
const BASE_URL =
  "https://travelens-fjbje8c5gnbeh7fr.indiasouthcentral-01.azurewebsites.net/admin";
// Some endpoints live at the host root (not under /admin), e.g. /get-messaging,
// /send-notification. ROOT_URL is BASE_URL with the trailing /admin stripped.
const ROOT_URL = BASE_URL.replace(/\/admin\/?$/, "");
const TOKEN_KEY = "travelens_admin_token";

export const tokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

export class ApiError extends Error {
  constructor(message, status) {
    super(message);
    this.status = status;
  }
}

// path is relative to BASE_URL, e.g. "/food-preferences?page=1".
// Pass { base } to hit a different origin (see rootRequest).
export async function request(
  path,
  { method = "GET", body, base = BASE_URL, headers = {} } = {},
) {
  const token = tokenStore.get();
  const res = await fetch(`${base}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
      ...headers,
    },
    ...(body != null && { body: JSON.stringify(body) }),
  });
  if (res.status === 401) {
    tokenStore.clear();
    window.location.hash = "/login";
  }
  if (!res.ok) {
    const payload = await res.json().catch(() => ({}));
    throw new ApiError(payload.message || res.statusText, res.status);
  }
  return res.status === 204 ? null : res.json();
}

// For host-root endpoints outside the /admin prefix (e.g. /get-messaging).
export const rootRequest = (path, opts = {}) =>
  request(path, { ...opts, base: ROOT_URL });

// Build "?page=&limit=&search=" from a params object, omitting empties.
export function qs(params = {}) {
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") usp.set(k, v);
  });
  const s = usp.toString();
  return s ? `?${s}` : "";
}
